"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _OrbitNetLabels = _interopRequireDefault(require("../Labels/OrbitNetLabels"));

var _ShipmentCardStyles = require("../../styles/ShipmentCardStyles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ShipmentCard = function ShipmentCard(_ref) {
  var _ref$group = _ref.group,
      group = _ref$group === void 0 ? false : _ref$group,
      id = _ref.id,
      className = _ref.className,
      shipment = _ref.shipment,
      ticket = _ref.ticket,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      onSelect = _ref.onSelect,
      onClick = _ref.onClick;
  return /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.Wrapper, {
    className: className,
    id: id,
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.WrapperShipment, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.WrapperShipmentInfo, null, !group && /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.IconShipment, {
    onClick: function onClick(event) {
      event.stopPropagation();
      onSelect(event);
    }
  }, selected && /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.IconSmallShipment, null)), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.TitleWrapperShipment, null, !group && /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.TravelShipment, null, "Viaje: ", shipment), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.FolioShipment, null, "Folio: ", ticket.number))), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.WrapperShipmentLogos, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.CompanyLogoShipment, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.CompanyLogoImgShipment, {
    src: ticket.companyLogo
  })), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.CourierLogoShipment, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.CourierLogoImgShipment, {
    src: ticket.courierLogo
  }))), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.WrapperShipmentLevel, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.ContainerLevelShipment, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.TitleLevelShipment, null, "Nivel"), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.NumberLevelShipment, null, ticket.level)))), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.LabelWrapper, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.WrapperOtherData, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.LocationOtherData, null, ticket.location), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.DatetimeOtherData, null, ticket.datetime)), /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.WrapperLabels, null, /*#__PURE__*/_react["default"].createElement(_ShipmentCardStyles.ManouverIconLabel, null, ticket.maneuverIcon), /*#__PURE__*/_react["default"].createElement(_OrbitNetLabels["default"], {
    labels: ticket.tags
  }))));
};

var _default = ShipmentCard;
exports["default"] = _default;